import React, { useState } from 'react';
import { Button as ANTButton, Form, Switch, Space } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import Select from 'components/Atom/Select';
import Input from 'components/Atom/Input';
import { Button } from 'components/Atom/Button';
import { useSelector } from 'react-redux';
import { addProduct, updateProduct } from 'api/subscriptions';
import { SUB_CurrencyNames } from 'utils/services';
import { notification } from 'antd';

const CreateProduct = ({ handleOpen, refetch, productData, isEdit }) => {
  const [isProductAdding, setIsProductAdding] = useState(false);
  const store = useSelector((state) => state.company.store);
  const userStores = useSelector((state) => state?.company?.userStores);
  const onAddSubmit = async (values) => {
    if (userStores?.length > 1 && !store?.isSelected && !isEdit) {
      notification.error({ message: 'Select store from the drop-down menu above', placement: 'bottomRight' });
      return;
    }
    setIsProductAdding(true);
    const { name, price, active, description, features, currency } = values;
    const FeatureValidArray = features?.filter((feat) => feat);

    const payload = {
      name,
      price: Number(price),
      active,
      currency: currency?.value,
      description,
      ...(FeatureValidArray?.length > 0 && { features: FeatureValidArray }),
    };
    const response = isEdit ? await updateProduct(productData?.store_id, productData?.product_id, payload) : await addProduct(store?._id, payload);
    if (response?.data?.success) {
      handleOpen();
      refetch();
    }
    setIsProductAdding(false);
  };

  const initialValues = isEdit && {
    name: productData?.name,
    price: productData?.price,
    active: productData?.active,
    currency: { label: productData?.currency, value: productData?.currency },
    description: productData?.description,
    features: productData?.features?.length > 0 ? productData?.features : [''],
  };
  return (
    <div className='formDetails'>
      <Form layout='vertical' onFinish={onAddSubmit} initialValues={initialValues}>
        <div className='create-form'>
          <Form.Item
            name='name'
            label='Name'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              !isEdit && {
                required: true,
                message: 'Product Name is required',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const regex = /^[^%?{}[\]$^@<>\"&!:;~*]+$/;
                  if (regex.test(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject('%?{}[]$^@<>"&!:;~* are not allowed.');
                  }
                },
              },
            ].filter(Boolean)}>
            <Input type='string' placeholder='Enter name' name='name' />
          </Form.Item>
          <Form.Item
            name='description'
            label='Description'
            className='customInput mobileInputView'
            rules={[
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const regex = /^[^{}[\]$^<>]+$/;
                  if (regex.test(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject('{}[]$^<> are not allowed.');
                  }
                },
              },
            ]}>
            <Input type='string' placeholder='Enter Description' name='description' />
          </Form.Item>
          <Form.Item
            name='price'
            label='Price'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              ...(!isEdit
                ? [
                    {
                      required: true,
                      message: 'Price is required',
                    },
                  ]
                : []),
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  if (/^\d+(\.\d+)?$/.test(value) && value?.length <= 15) {
                    return Promise.resolve();
                  }
                  if (!/^\d+(\.\d+)?$/.test(value)) {
                    return Promise.reject('Only positive numbers are allowed');
                  }
                  if (value.length > 15) {
                    return Promise.reject('Maximum 15 digits are allowed');
                  }
                  return Promise.resolve();
                },
              },
            ]}>
            <Input type='number' placeholder='Enter Price' name='price' />
          </Form.Item>

          <Form.Item
            name='currency'
            label='Currency'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={
              !isEdit && [
                {
                  required: true,
                  message: 'Currency is required',
                },
              ]
            }>
            <Select showSearch defaultValue={'Select Currency'} optionsValue={SUB_CurrencyNames} />
          </Form.Item>
        </div>
        <Form.List name='features' initialValue={['']}>
          {(fields, { add, remove }) => (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '4px' }}>
                <label style={{ fontSize: '14px !important', fontWeight: '475' }}>Features</label>
                <PlusCircleOutlined style={{ marginLeft: '10px', fontSize: '15px' }} onClick={() => add()} />
              </div>
              <div className='feature-div'>
                {fields?.map((field, index) => (
                  <Space key={field?.key} align='start' className='feature-Input'>
                    <Form.Item
                      {...field}
                      name={[field?.name]}
                      className='customInput mobileInputView'
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();
                            const regex = /^[^{}[\]$^<>]+$/;
                            if (regex.test(value)) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('{}[]$^<> are not allowed.');
                            }
                          },
                        },
                      ]}>
                      <Input placeholder='Enter feature' className='feature' />
                    </Form.Item>
                    {fields?.length > 1 ? <MinusCircleOutlined style={{ fontSize: '15px', marginTop: '11px' }} onClick={() => remove(field?.name)} /> : null}
                  </Space>
                ))}
              </div>
            </div>
          )}
        </Form.List>
        <Form.Item name='active' label='Active' valuePropName='checked' initialValue={true} className='customInput mobileInputView'>
          <Switch defaultChecked />
        </Form.Item>
        <div className='mb-[-20px] form_button update-button'>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <ANTButton block className='rounded-lg' onClick={() => handleOpen()}>
                Cancel
              </ANTButton>
              <Button block className='button-theme ml-4 rounded-lg' htmlType='submit' loading={isProductAdding}>
                {isEdit ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};
export default CreateProduct;
